<template>
  <div>
    <v-btn color="orange" class="" icon @click="dialog = true"
      ><v-icon>mdi-pencil</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Edit Supplier"
          icon="mdi-account"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field
            outlined
            dense
            label="Supplier Name"
            v-model="item.supplier_name"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Batch Prefix (e.g. UM for UMAL)"
            v-model="item.batch_prefix"
            prepend-icon="mdi-tag"
            hint="Used to auto-generate batch tags like UM-22-C"
            persistent-hint
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Contact Person"
            v-model="item.contact_person"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Supplier Contact"
            v-model="item.supplier_contact_no"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Contact Platform"
            v-model="item.contact_platform"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="Supplier Address"
            v-model="item.supplier_address"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-percent"
            label="Vat Percentage"
            v-model="item.vat_percentage"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-cart"
            label="Item Sales"
            v-model="item.item_sales"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-bank"
            label="Bank Account #"
            v-model="item.bank_account_number"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            prepend-icon="mdi-account"
            label="Bank Account Name"
            v-model="item.bank_account_name"
          ></v-text-field>
          <v-select
            outlined
            dense
            prepend-icon="mdi-cash"
            label="Payment Method"
            v-model="item.payment_method"
            :items="paymentMethods"
            clearable
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" :loading="loading">Edit</v-btn>
          <v-btn @click="dialog = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      loading: false,
      dialog: false,
      paymentMethods: ["FundTransfer", "Gcash", "Cash on Delivery"],
    };
  },
  methods: {
    ...mapActions({
      edit_supplier: "supplier/edit_supplier",
    }),
    async submit() {
      this.loading = true;
      await this.edit_supplier(this.item);
      this.$alert({
        title: "Success",
        message: "You have successfully edited a new supplier!",
        color: "success",
        icon: "mdi-check-circle",
      });
      this.loading = false;
      //   console.log(this.item);
    },
  },
};
</script>

<style lang="scss" scoped></style>
